import dayjs from 'dayjs'
const utc = require('dayjs/plugin/utc')
// const isToday = require('dayjs/plugin/isToday')
const timezone = require('dayjs/plugin/timezone')
dayjs.extend(timezone)
dayjs.extend(utc)
// dayjs.extend(isToday)

export default dayjs
